import { NbDialogService, NbToastrService } from '@nebular/theme';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { ServicesService } from '../../services/servicesService';
import { BaseComponent } from '../../../../shared/Components/base/base.component';
import { AddServiceComponent } from '../add-service/add-service.component';
import { UpdateServiceComponent } from '../update-service/update-service.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PagingService } from '../../../../shared/Services/PagingService';
import { ConfirmationDialogComponent } from '../../../../shared/Components/confirmation-dialog.component';

export interface serviceType {
  id: number;
  nameAr: string;
  nameEn: string;
}

@Component({
  selector: 'ngx-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.scss'],
})
export class ServicesComponent extends BaseComponent implements OnInit {
  linearMode = true;
  servicesList: serviceType[] = [];
  form: FormGroup;
  dataSet = {
    showLabels: false,
    showNumber: false,
  };
  config = {
    displayKey: 'description', // if objects array passed which key to be displayed defaults to description
    search: false, // true/false for the search functionlity defaults to false,
    height: 'auto', // height of the list so that if there are mor
    customComparator: () => {}, // a custom function using which user wants to sort the items.
    // default is undefined and Array.sort() will be used in that case,
    // limitTo: this.options.length, // a number thats limits the no of options displayed in the UI similar to angular's limitTo pipe
    moreText: 'more', // text to be displayed whenmore than one items are selected like Option 1 + 5 more
    noResultsFound: 'لا يوجد نتائج !', // text to be displayed when no items are found while searching
    searchPlaceholder: 'نوع الخدمة', // label thats displayed in search input,
    searchOnKey: 'description', // key on which search should be performed this will be selective search.
    clearOnSelection: false, // clears search criteria when an option is selected if set to true, default is false
    inputDirection: 'ltr',
    placeholder: 'نوع الخدمة',
    // the direction of the search input can be rtl or ltr(default)
  };

  constructor(
    public service: ServicesService,
    route: Router,
    private diag: NbDialogService,
    private toast: NbToastrService,
    private fb: FormBuilder,
    private paging: PagingService
  ) {
    super(route, service, null);
  }

  ngOnInit() {
    this.intitForm();
    this.getServices();
    this.loadEntities();
  }

  setPage(page: number) {
    this.finishLoading = false;
    this.paging.setPage(page, this.pagingModel, this.service);
    this.finishLoading = true;
  }

  //   typeSelected(data){
  // console.log(data)
  // debugger

  //   }

  getServices() {
    this.service.getServiceTypes().subscribe({
      next: (res) => {
        this.servicesList = res.result.map((service) => {
          return {
            ...service,
            name: service.nameAr,
          };
        });
      },
    });
  }
  getServicesFiltered() {
    let searchArr = [];

    if (this.form.controls['name'].value.trim()) {
      searchArr.push(`name:${this.form.controls['name'].value.trim()}`);
    }

    if (this.form.controls['serviceTypeId'].value) {
      searchArr.push(`serviceTypeId:${this.form.controls['serviceTypeId'].value}`);
    }

    this.loadEntitiesWithFilter(searchArr.join(','));

    // const filter = {
    //   name: this.form.controls['name'].value,
    //   serviceTypeId: this.form.controls['serviceTypeId'].value ? this.form.controls['serviceTypeId'].value : '',
    // };

    // const nameTerm = filter.name != '' ? `name:${filter.name}` : ''
    // const serviceTypeTerm = filter.serviceTypeId != null ? `serviceTypeId:${filter.serviceTypeId}` : ''
    // let searchTerm = [nameTerm, serviceTypeTerm].filter(term => term).join(',');
  }

  detail(id: number) {
    const route = ['admin/services-detail/' + id];
    this.route.navigate(route);
  }
  addNewService() {
    this.diag.open(AddServiceComponent).onClose.subscribe((res) => {
      console.log(res);
      if (res === 'true') {
        this.loadEntities();
      }
    });
  }
  update(serviceid) {
    this.diag.open(UpdateServiceComponent, { context: { serviceId: serviceid } }).onClose.subscribe((res) => {
      if (res === 'true') {
        this.loadEntities();
      }
    });
  }
  delete(serviceId) {
    this.diag
      .open(ConfirmationDialogComponent, {
        context: { message: 'Are you sure you want to delete this item?' } as Partial<ConfirmationDialogComponent>,
      })
      .onClose.subscribe((result) => {
        if (result) {
          this.service.delete(serviceId).subscribe(() => {
            this.toast.show('تم حذف الخدمة بنجاح', '', { status: 'success', duration: 3000 });
            this.loadEntities();
          });
        }
      });
  }

  intitForm() {
    this.form = this.fb.group({
      name: [''],
      serviceTypeId: [''],
    });
  }

  handleSearch() {
    if (this.form.controls['name'].value == '' && this.form.controls['serviceTypeId'].value == '') {
      this.toast.danger('برجاءاختيار نوع الخدمة او البحث بواسطة الاسم لاتمام عملية البحث', 'رساله تحذيرية');
    } else {
      this.getServicesFiltered();
    }
  }

  clearFilter() {
    this.form.controls['serviceTypeId'].setValue('');
    this.form.controls['name'].setValue('');
    this.pagingModel.query.searchTerm = '';
    this.loadEntities();
  }
}
